import { ReactComponent as Calendar } from "./calendar.svg";
import { ReactComponent as Camera } from "./camera.svg";
import { ReactComponent as Email } from "./email.svg";
import { ReactComponent as Instagram } from "./instagram.svg";
import { ReactComponent as Linktree } from "./linktree.svg";
import { ReactComponent as Logo } from "./logo.svg";
import { ReactComponent as Play } from "./play.svg";
import { ReactComponent as Vimeo } from "./vimeo.svg";
import { ReactComponent as WorldMap } from "./worldmap.svg";

const SvgImages = {
	logo: Logo,
	play: Play,
	instagram: Instagram,
	linktree: Linktree,
	vimeo: Vimeo,
	email: Email,
	camera: Camera,
	worldmap: WorldMap,
	calendar: Calendar,
	// Add more SVG imports here as needed
};

export default function getImage(iconName) {
	const image = SvgImages[iconName];
	if (!image) {
		console.warn(`SVG image "${iconName}" not found.`);
	}
	return image || null;
}
